/**
 * VERSIONE LIBRERIA 3.0
 */
/**
 * RenderInput
 * campi in piu' in config rispetto alla class Render di default
 * config.operator : valore dell'operatore search
 **/
var RenderInput = Render.extend({
    inputType : 'text',
    type : 'input',
    classData : 'input',
    classTemplate : 'input',
    operator : null,
    htmlAttributes : {},
/*    init : function (key,attributes) {
        this.htmlAttributes = {};
        this._super(key,attributes);
    },*/
    _renderSearch : function (jQe) {
        var self = this;
        var el = jQe.find(self.control_selector);
        el.attr("type",self.inputType);
        el.attr("name", 's_' + self.key + '[]');
        el.attr("value", self.value);
        $('<input>').attr({
            type: 'hidden',
            name: 's_' + self.key + "_operator",
            'data-control_operator' : self.key,
            value : self.operator
        }).appendTo(jQe);
        self._setHtmlAttributes(jQe);
    },
    _finalizeSearch : function (){} ,
    _renderEdit : function (jQe) {
        var self = this;
        var el = jQe.find(self.control_selector);
        el.attr("type",self.inputType);
        el.attr("name", self.key);
        el.attr("value", self.value);
        self._setHtmlAttributes(jQe);
    },
    _renderView : function (jQe) {
        var self = this;
        self._renderEdit(jQe);
    },
    _finalizeView : function(){},
    _finalizeEdit : function(){
        var self = this;
        $(self.container).find(self.control_selector).change(function() {
            self._emitEvent('change',$(this).val());
        });
    },
    _setHtmlAttributes : function(jQe) {
        var self = this;
        var el = jQe.find(self.control_selector);
        for(var k in self.htmlAttributes) {
            el.attr(k,self.htmlAttributes[k]);
        }
    }
});
